module.exports = __webpack_public_path__ + "img/DV360.edaeeccd.svg";